import applicationLanguage from '@shared/module/applicationLanguage'
import { currencyOverride } from '@/i18n/formats'

class NumberFormatOverridden extends Intl.NumberFormat {
    mapPart({ type, value }) {
        const config = this.configuration()
        switch (type) {
            case 'group':
                return config.groupSeparator || value
            case 'decimal':
                return config.decimalSeparator || value
            default :
                return value
        }
    }

    format(number) {
        const parts = super.formatToParts(number)

        if (parts.some((part) => part.type === 'currency')) {
            currencyOverride(parts, applicationLanguage())
        }

        return parts.map(this.mapPart.bind(this)).join('')
    }
}

function defaultFractionDigitsForCurrency(currency) {
    switch (currency) {
        case 'ALL':
        case 'MKD':
            return 0
        default: return 2
    }
}

export default {
    install: function (vue, configOptions) {
        Intl.NumberFormat = NumberFormatOverridden
        NumberFormatOverridden.prototype.configuration = configOptions.configurationSupplier
        vue.prototype.$currency = function (value, currency) {
            if (!value && value !== 0) return ''
            const fractionDigits = defaultFractionDigitsForCurrency(currency)
            return this.$n(value, {
                style: 'currency',
                currency: currency,
                minimumFractionDigits: fractionDigits,
                maximumFractionDigits: fractionDigits
            })
        }
    }
}
